<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("common.report") }}</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <header-action
            :button="buttonSearch"
            :data.sync="studentData"
            @studentValue="studentData.value = $event"
          ></header-action>
          <student-list
            :data="data"
            :pagination="pagination"
            :action-search="buttonSearch"
          ></student-list>

          <div class="md-layout mt-7">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <h6 class="title text-md font-semibold normal-case text-xl">
                {{ $t("student.note") }}
              </h6>
              <table-proficiency-ranges type="SMI"></table-proficiency-ranges>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import HeaderAction from "./HeaderAction";
import StudentList from "./TestsOfStudent";
import { service_paths } from "@/constants/Services";
import TableProficiencyRanges from "../../../components/TableProficiencyRanges";

export default {
  components: {
    TableProficiencyRanges,
    StudentList,
    HeaderAction
  },
  data() {
    return {
      formData: null,
      studentData: {
        value: "",
        grade: ""
      },
      pagination: {
        ...{
          perPage: 10,
          from: 0,
          to: 0,
          total: 0,
          currentPage: 0,
          hidePaging: false,
          hidePerPageOptions: false
        },
        ...this.paginationCfg
      },
      params: {
        page: 1,
        limit: 10
      },
      data: {},
      buttonSearch: {
        title: this.$t("common.search"),
        action: this.searchStudent
      }
    };
  },
  computed: {},
  created() {
    this.searchStudent();
  },
  methods: {
    searchStudent(value) {
      console.log(value);
      this.params.page = value ? value.page : this.params.page;
      this.params.limit = value ? value.limit : this.params.limit;
      let params = Object.assign(
        {
          _id: this.studentData.value,
          grade: this.studentData.grade
        },
        this.params
      );
      this.search(params);
    },
    search(params) {
      this.$axios
        .get(`${service_paths.sri_smi}/report`, params)
        .then(response => {
          this.data = response.data.data;
          this.pagination.from = response.data.from;
          this.pagination.to = response.data.to;
          this.pagination.total = response.data.total;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-empty-page {
  text-align: center;
  width: 100%;
  .student-image {
    border: none;
    display: inline-block;
  }
}
</style>
